import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'

import { getIsFetching, getSecureCode } from 'src/comps/PayNow/selectors'
import { payNowRequestAction } from 'src/comps/PayNow/actions'

import ButtonSimple from 'src/comps/ButtonSimple'
import CreditCardInfo from 'src/comps/CreditCardInfo'

import { ButtonWrapper, ChangeCreditCardLink, PayNowBase, Row } from './styles'

import messages from './messages'
import PayPartialNow from './PayPartialNow'
import PayAll from './PayAll'
import Price from 'client/components/Price'
import EmbedHtml from '../EmbedHtml'
import { useDevice } from 'src/hooks/useDevice'

const PayNow = ({
  bookingHash,
  brand,
  currency,
  expiryDate,
  handleCloseModal,
  holder,
  number,
  isPartialPay = false,
  partialAmounts = {},
  pendingAmount,
  purchaseId,
}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isFetching = useSelector(getIsFetching)
  const secureCode = useSelector(getSecureCode)
  const [amount, setAmount] = useState(isPartialPay ? partialAmounts.min : pendingAmount)
  const { colorDepth, javaEnabled, language, screenHeight, screenWidth, timeZone } = useDevice()

  function handlePayNow(e) {
    e.preventDefault()

    dispatch(
      payNowRequestAction({
        purchaseId,
        creditCardNumber: number,
        amount: <Price amount={amount} currency={currency} />,
        rawAmount: amount,
        bookingHash,
        browserColorDepth: colorDepth,
        browserJavaEnabled: javaEnabled,
        browserLanguage: language,
        browserScreenHeight: screenHeight,
        browserScreenWidth: screenWidth,
        browserTimeZone: timeZone,
      })
    )
  }

  return (
    <>
      <EmbedHtml isBase64>{secureCode}</EmbedHtml>
      <PayNowBase onSubmit={handlePayNow}>
        {isPartialPay ? (
          <PayPartialNow
            amount={amount}
            currency={currency}
            partialAmounts={partialAmounts}
            handleAmount={setAmount}
          />
        ) : (
          <PayAll currency={currency} pendingAmount={pendingAmount} />
        )}

        <Row>
          <CreditCardInfo
            holder={holder}
            number={number}
            expiryDate={expiryDate}
            brand={brand}
            inputRadioWrapped
          />
        </Row>

        <Row>
          <ChangeCreditCardLink onClick={handleCloseModal}>
            <FormattedMessage {...messages.changeCreditCard} tagName="div" />
          </ChangeCreditCardLink>
        </Row>

        <ButtonWrapper>
          <ButtonSimple
            fullWidth
            isLoading={isFetching}
            text={intl.formatMessage(messages.payNow)}
            variant="primary"
          />
        </ButtonWrapper>
      </PayNowBase>
    </>
  )
}

PayNow.propTypes = {
  brand: PropTypes.string,
  currency: PropTypes.string,
  expiryDate: PropTypes.string,
  handleCloseModal: PropTypes.func,
  holder: PropTypes.string,
  number: PropTypes.string,
  isPartialPay: PropTypes.bool,
  partialAmounts: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  pendingAmount: PropTypes.number,
  purchaseId: PropTypes.string,
  roomName: PropTypes.string,
  bookingHash: PropTypes.string,
}

export default PayNow
